import { render, staticRenderFns } from "./login_form.vue?vue&type=template&id=83d18648&scoped=true"
import script from "./login_form.vue?vue&type=script&lang=js"
export * from "./login_form.vue?vue&type=script&lang=js"
import style0 from "./login_form.vue?vue&type=style&index=0&id=83d18648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d18648",
  null
  
)

export default component.exports